<template>
    <div v-if="true === loading" class="container">
        <div class="row">
            <div class="col-12">
                <loading/>
            </div>
        </div>
    </div>
    <layout-two-column v-else>
        <template v-if="0 < groupings.length" #column>
            <panel>
                <tree-view :items="groupings" :value="groupingActiveId" @select="navigate"/>
            </panel>
        </template>

        <template #default>
            <loading v-if="loading"/>
            <products-product-page v-else-if="product" :value="product"/>
            <div v-else>{{t('unavailable')}}</div>
        </template>
    </layout-two-column>
</template>

<script>

    import {mapGetters} from "vuex";
    import {get} from "lodash";

    import mixin_view from "@/mixins/view";
    import mixin_catalog from "@/mixins/catalog";
    import mixin_products from "@/mixins/products";
    import {retryRequest} from "@/helpers/request";
    import {HOME_PAGE_GROUPING_TYPE} from "@/constants";
    import emitter from "@/api/events";

    import LayoutTwoColumn from "@/components/layout/LayoutTwoColumn";
    import Panel from "@/components/Panel";
    import ProductsProductPage from "@/components/products/product/ProductsProductPage";
    import TreeView from "@/components/TreeView";

    export default {
        name: "ViewsProductsProduct",
        mixins: [mixin_view, mixin_catalog, mixin_products],
        components: {
            LayoutTwoColumn,
            Panel,
            ProductsProductPage,
            TreeView
        },
        data() {

            return {
                t_path: "views.products.product",
                loading: false,
                product: null
            }
        },
        computed: {
            ...mapGetters({
                groupingActiveId: "grouping/activeId"
            }),
            groupings() {

                return this.catalog_getCategories();
            }
        },
        methods: {
            navigate(id) {

                this.$router.push({
                    name: "products",
                    params: {
                        grouping: this.$route.params.grouping,
                        grouping_id: id
                    }
                });
            },
            fetch() {

                this.loading = true;

                emitter.emit('grouping_product_before_load');

                this.catalog_fetchCategories({
                        type: get(this.$route.params, "grouping", HOME_PAGE_GROUPING_TYPE),
                        activeId: this.$route.params.grouping_id
                    })
                    .then(() => retryRequest(() => this.$platform.get(`/api/v2/grouping/product/${encodeURIComponent(this.$route.params.sku)}`)))
                    .then(response => {

                        if (0 < response.data.results.length) {

                            this.product = response.data.results[0]

                            emitter.emit('grouping_product_after_load');
                        }
                    })
                    .finally(() => this.loading = false);
            },
            refresh() {

                this.products_updateBreadcrumbsProduct(this.product);
                this.view_setTitle(this.products_translateProductName(this.product));
            },
            silentReload() {

                emitter.emit('grouping_product_before_load');

                this.$platform
                    .get(`/api/v2/grouping/product/${encodeURIComponent(this.$route.params.sku)}`)
                    .then(response => {

                        if (0 < response.data.results.length) {

                            this.product = response.data.results[0]

                            emitter.emit('grouping_product_after_load');
                        }
                    });
            }
        },
        watch: {
            "$i18n.locale": function () {

                this.refresh();
            },
            product() {

                this.refresh();
            }
        },
        mounted() {

            this.fetch();

            emitter.on('user_cart_change', this.silentReload);
        },
        beforeUnmount() {

            emitter.off('user_cart_change');
        }
    }
</script>